// import My from '@/view/my/Index.vue'
import { NativeTabNavigatoLayout } from '@/layout'

const routes = [
  {
    path: '/uploadFile',
    name: '/uploadFile',
    component: () => import('@/view/uploadFile/UploadFile.vue')
  },
  {
    path: '/selectFile',
    name: '/selectFile',
    component: () => import('@/view/uploadFile/SelectFile.vue')
  },
]

export default { routes }